// src/context/NotificationContext.js
import React, { createContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import socket from "./socket.js";  // <-- correct path if needed
// NotificationContext.js
export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userType = localStorage.getItem("userType");

    const allowedRoles = ["admin", "BSE", "team_leader"];
    if (token && allowedRoles.includes(userType)) {
      socket.on("getNotification", (data) => {
        console.log("🔔 Notification received:", data);
        enqueueSnackbar(data.message, { variant: "info" });

        // Add "viewed: false" to mark as unread
        setNotifications((prev) => [{ ...data, viewed: false }, ...prev]);
      });

      return () => {
        socket.off("getNotification");
      };
    }
  }, [enqueueSnackbar]);

  const markAllAsViewed = () => {
    setNotifications((prev) =>
      prev.map((notif) => ({ ...notif, viewed: true }))
    );
  };

  const unreadNotifications = notifications.filter((notif) => !notif.viewed);

  return (
    <NotificationContext.Provider
      value={{ notifications, unreadNotifications, markAllAsViewed }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
